import React from 'react';
import { CtaButton } from './CtaButton';
import { CountdownPanel } from './CountdownPanel';
import { TrustIcons } from './TrustIcons';
import { checkoutUrl, offer } from '../data/content';
interface PricingProps {
  showUrgency?: boolean;
}
export function Pricing({
  showUrgency = true
}: PricingProps) {
  return <section id="inversion" className="w-full bg-white py-16 md:py-24" data-id="element-105" data-mp="2jknqblhfrnqr">
      <div className="mx-auto w-full max-w-content px-5 md:px-8" data-id="element-106" data-mp="1vts18w4d76n7">
        {showUrgency && <CountdownPanel headline="Oferta especial de lanzamiento: vence en 48 horas" subtext="Después, el precio vuelve a $24.990. Mañana es tarde." data-id="element-107" data-mp="1rsq0gausumj4" />}

        <h2 className="mt-16 text-center font-display text-[2rem] font-extrabold leading-tight tracking-tight text-ink md:text-5xl" data-id="element-108" data-mp="20teg19zucuy4">
          Tu inversión hoy
        </h2>

        <div className="mx-auto mt-10 max-w-narrow rounded-3xl bg-canvas p-7 text-center shadow-lift ring-1 ring-gray-200 md:p-12" data-id="element-109" data-mp="3h9hczoy9bdzl">
          <p className="text-lg text-gray-500" data-id="element-110" data-mp="3vzylsdwtf31i">
            Valor regular: <span className="line-through" data-id="element-111" data-mp="3w1jfk1bb2hyb">{offer.listPrice} ARS</span>
          </p>

          <p className="mt-4 font-display text-6xl font-extrabold leading-none tracking-tight text-plum-700 md:text-7xl" data-id="element-112" data-mp="4rb01wunxdtf">
            {offer.price}
            <span className="ml-2 align-middle text-xl font-semibold text-gray-500" data-id="element-113" data-mp="erv5lbp7t4hg">
              {offer.currency}
            </span>
          </p>

          <p className="mt-5 inline-block rounded-lg bg-rose-200 px-4 py-1.5 font-display text-sm font-extrabold uppercase tracking-wide text-plum-900" data-id="element-114" data-mp="3dasb9e66dhqs">
            {offer.subtitle}
          </p>

          <p className="mx-auto mt-7 max-w-xl text-lg leading-relaxed text-gray-500" data-id="element-115" data-mp="3n5k64a8dhqhv">
            {offer.detail}
          </p>

          <div className="mt-9" data-id="element-116" data-mp="3rzoduvpgq2k0">
            <CtaButton size="xl" href={checkoutUrl} className="w-full" data-id="element-117" data-mp="2uj9a7cvpodre">
              {offer.cta}
            </CtaButton>
          </div>
        </div>

        <TrustIcons className="mt-10" data-id="element-118" data-mp="2zfg3o66x7wsg" />
      </div>
    </section>;
}